import { toast } from 'vue-sonner'

export interface notificationInterface {
  text: string
  timeout?: number
  persist?: boolean
  action?: {
    label: string
    onClick: () => void
  }
}

export interface useNotificationInterface {
  create: (type: 'success' | 'error', notification: notificationInterface) => void
  closeNotificationModal: (id?: string) => void
}

export const buildToastOptions = (notification: notificationInterface) => ({
  duration: notification.persist ? Infinity : (notification.timeout ?? 4000),
  ...(notification.action && { action: notification.action })
})

export default function useNotification(): useNotificationInterface {
  const create = (type: 'success' | 'error', notification: notificationInterface) => {
    const options = buildToastOptions(notification)

    if (type === 'success') {
      toast.success(notification.text, options)
    } else {
      toast.error(notification.text, options)
    }
  }

  const closeNotificationModal = (id?: string) => {
    if (id) {
      toast.dismiss(id)
    } else {
      toast.dismiss()
    }
  }

  return {
    create,
    closeNotificationModal
  }
}
